var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav_top flex"},[_c('van-button',{staticClass:"nav_home",on:{"click":function($event){return _vm.openPage('home')}}},[_vm._v("返回首页")]),_c('van-button',{staticClass:"nav_user",on:{"click":function($event){return _vm.openPage('user')}}},[_vm._v("个人中心")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }